import React, { useContext, useState } from 'react';
import { Form, Input, Space, Button, Select, Row, Col } from '@drip/drip-design';
import ComponentLog from '@/components/component-log';
import SelectCategories from '@/form-component/select-category';
import DepartmentCascader from './department-cascader';
import TimestampRangePicker from '@/components/timestamp-RangePicker';
import ContextProviderMenus from '@/components/slide-menu/provide-slide-menu';
import moment from 'moment';
import { UpOutlined, DownOutlined } from '@ant-design/icons';

function FilterSearchForm({ commitSearch }: any) {
  const [form] = Form.useForm();
  const label = useContext(ContextProviderMenus).label;
  const [stretch, setStretch] = useState(false);

  const onFinish = (val: any) => {
    let minActivityBeginTime, maxActivityBeginTime, firstDeptCodeList, secondDeptCodeList;
    const actTime = val.actTime || { minActivityBeginTime, maxActivityBeginTime };
    firstDeptCodeList = val.deptCodeList?.firstDeptCodeList;
    secondDeptCodeList = val.deptCodeList?.secondDeptCodeList;
    const _val = Object.assign({}, val, { ...actTime, firstDeptCodeList, secondDeptCodeList });
    delete _val.actTime;
    delete _val.deptCodeList;
    commitSearch(_val);
  };

  return (
    <Form form={form} onFinish={onFinish}>
      <Row gutter={[8, 8]} className="assign-search-form">
        <Col span={6}>
          <Form.Item label="活动名称" name="cardActivityName" colon={false}>
            <Input placeholder="请输入" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <Form.Item label="活动编号" name="cardActivityId" colon={false}>
            <Input placeholder="请输入" />
          </Form.Item>
        </Col>
        <Col span={6}>
          <ComponentLog clstag="yx_center__1665485895176|1">
            <Form.Item label="所属类目" name="categoryIds" colon={false}>
              {/**@ts-ignore */}
              <SelectCategories
                mode="multiple"
                placeholder="请选择"
                maxTagCount="responsive"
                className={'all-about-me-signed-activity-select'}
              />
            </Form.Item>
          </ComponentLog>
        </Col>
        <Col span={6}>
          <div className="btn-form">
            <Space size={8}>
              <ComponentLog clstag="yx_center_1629184833805|83">
                <Button type="primary" shape="round" htmlType="submit">
                  查询
                </Button>
              </ComponentLog>
              <ComponentLog clstag="yx_center_1629184833805|84">
                <Button
                  shape="round"
                  onClick={() => {
                    form.resetFields();
                    form.submit();
                  }}
                >
                  重置
                </Button>
              </ComponentLog>
              <a onClick={() => setStretch(!stretch)} className="form-isSretch">
                {stretch ? (
                  <>
                    收起
                    <UpOutlined className="icon" />
                  </>
                ) : (
                  <>
                    展开
                    <DownOutlined className="icon" />
                  </>
                )}
              </a>
            </Space>
          </div>
        </Col>
        {stretch ? (
          <>
            <Col span={12}>
              <Form.Item label="活动时间" name="actTime" colon={false}>
                <TimestampRangePicker
                  style={{ width: '100%' }}
                  type={TimestampRangePicker.DATA_STRING}
                  showTime={{ defaultValue: [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')] }}
                  fieldNames={{ start: 'minActivityBeginTime', end: 'maxActivityBeginTime' }}
                />
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="benefitTags" label="利益点" colon={false}>
                <Select
                  mode="multiple"
                  placeholder="请选择"
                  maxTagCount="responsive"
                  className={'all-about-me-signed-activity-select'}
                >
                  {label.benefitTags?.map((item: any) => (
                    <Select.Option value={item.code} key={item.code}>
                      {item.name}
                    </Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={6}>
              <Form.Item name="deptCodeList" label="发起部门" colon={false}>
                <DepartmentCascader
                  style={{ width: '100%' }}
                  maxTagCount="responsive"
                  className={'all-about-me-signed-activity-select'}
                />
              </Form.Item>
            </Col>
          </>
        ) : null}
      </Row>
    </Form>
  );
}

export default FilterSearchForm;
